import { gql } from '@apollo/client';

export const SUBSCRIBE = gql`
  subscription Subscription {
    fileValidation
  }
`;
